import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vModelText as _vModelText, withKeys as _withKeys, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "formulario-modelo" }
const _hoisted_2 = { class: "header-flex" }
const _hoisted_3 = { class: "controles" }
const _hoisted_4 = { class: "tabs" }
const _hoisted_5 = { class: "filtros-linea" }
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 0,
  class: "skeleton-grupo"
}
const _hoisted_8 = {
  key: 1,
  class: "aviso-error"
}
const _hoisted_9 = {
  key: 0,
  class: "tarjeta"
}
const _hoisted_10 = { class: "mes-nav" }
const _hoisted_11 = { class: "grilla-wrap" }
const _hoisted_12 = { class: "grilla" }
const _hoisted_13 = { class: "num-dia" }
const _hoisted_14 = ["title", "onClick"]
const _hoisted_15 = { class: "leyenda" }
const _hoisted_16 = {
  key: 1,
  class: "tarjeta"
}
const _hoisted_17 = { class: "agenda-tabs" }
const _hoisted_18 = {
  key: 0,
  class: "vacio"
}
const _hoisted_19 = {
  key: 1,
  class: "agenda"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "cuenta-num" }
const _hoisted_22 = { class: "cuenta-lbl" }
const _hoisted_23 = { class: "agenda-cuerpo" }
const _hoisted_24 = { class: "agenda-titulo" }
const _hoisted_25 = { class: "agenda-meta" }
const _hoisted_26 = {
  key: 3,
  class: "overlay"
}
const _hoisted_27 = { class: "modal" }
const _hoisted_28 = { class: "form-grid" }
const _hoisted_29 = ["value"]
const _hoisted_30 = ["label"]
const _hoisted_31 = ["value"]
const _hoisted_32 = ["value"]
const _hoisted_33 = ["value"]
const _hoisted_34 = { class: "campo-full" }
const _hoisted_35 = { class: "campo-full" }
const _hoisted_36 = { class: "chips" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "campo-full dest" }
const _hoisted_39 = { class: "dest-cols" }
const _hoisted_40 = ["value"]
const _hoisted_41 = ["value"]
const _hoisted_42 = {
  key: 0,
  class: "aviso-error"
}
const _hoisted_43 = { class: "modal-pie" }
const _hoisted_44 = {
  key: 0,
  class: "acciones-estado"
}
const _hoisted_45 = {
  key: 1,
  class: "aplazar-linea"
}
const _hoisted_46 = { class: "botones" }
const _hoisted_47 = ["disabled"]

import { ref, reactive, computed, onMounted } from 'vue'
import useAutenticar from '@/store/IngresoAutenticar'
import { useDashboardFiltros } from '@/store/DashboardFiltros'
import { useGestionProcesos } from '@/store/GestionProcesoAutoevaluacion'
import { listarRoles, listarUsuarios } from '@/services/RegistroUsuariosService'
import { getProgramasService } from '@/services/ProgramaService'
import {
  getEventosService, getTiposEventoService, crearEventoService,
  actualizarEventoService, cambiarEstadoEventoService,
  type EventoCalendario, type TipoEvento, type EstadoEvento
} from '@/services/CalendarioService'
import { getCampusService } from '@/services/CampusService'
import type { Campus } from '@/interfaces/Campus'


export default /*@__PURE__*/_defineComponent({
  __name: 'CalendarioAcreditacionView',
  setup(__props) {

/**
 * Calendario de acreditación con recordatorios.
 *
 * Las alertas A1 y A6 leen estos eventos para avisar de fechas próximas y de
 * fechas pasadas sin gestionar.
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

const auth = useAutenticar()
const filtros = useDashboardFiltros()
const procesosStore = useGestionProcesos()

const puedeGestionar = computed(() => auth.tienePermiso('calendario.gestionar'))

const eventos = ref<EventoCalendario[]>([])
const tipos = ref<TipoEvento[]>([])
const roles = ref<Array<{ id: number; name: string; label?: string }>>([])
const usuarios = ref<Array<{ id?: number; name: string | null }>>([])
const areas = ref<Array<{ id_programa: number; nombre: string; tipo?: string }>>([])

/**
 * Áreas agrupadas por tipo para el selector del evento.
 *
 * Los programas van primero porque son lo que se elige casi siempre; el resto
 * del organigrama queda disponible pero sin estorbar. Un evento puede apuntar a
 * una facultad (una visita de pares, por ejemplo), así que no se filtran.
 */
const areasAgrupadas = computed(() => {
  const orden = ['programa', 'facultad', 'vicerrectoria', 'direccion', 'oficina', 'rectoria', 'presidencia']
  const etiquetas: Record<string, string> = {
    programa: 'Programas',
    facultad: 'Facultades',
    vicerrectoria: 'Vicerrectorías',
    direccion: 'Direcciones',
    oficina: 'Oficinas',
    rectoria: 'Rectoría',
    presidencia: 'Presidencia'
  }

  const porTipo = new Map<string, typeof areas.value>()
  for (const a of areas.value) {
    const tipo = a.tipo ?? 'otros'
    if (!porTipo.has(tipo)) porTipo.set(tipo, [])
    porTipo.get(tipo)!.push(a)
  }

  const claves = [...porTipo.keys()].sort((a, b) => {
    const ia = orden.indexOf(a), ib = orden.indexOf(b)
    return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib)
  })

  return claves.map(tipo => ({
    tipo: etiquetas[tipo] ?? tipo,
    areas: [...porTipo.get(tipo)!].sort((a, b) => a.nombre.localeCompare(b.nombre))
  }))
})
const campusList = ref<Campus[]>([])
const cargando = ref(false)
const error = ref('')

const mesRef = ref(new Date(new Date().getFullYear(), new Date().getMonth(), 1))

const LEYENDA: Record<string, string> = {
  vencimiento: 'Vencimientos', radicacion: 'Radicaciones', visita: 'Visitas de pares', otro: 'Otros'
}

function colorTipo(tipo: string): string {
  if (tipo.startsWith('vencimiento')) return 'vencimiento'
  if (tipo === 'radicacion') return 'radicacion'
  if (tipo === 'visita_pares') return 'visita'
  return 'otro'
}
function urgencia(dias: number): string {
  return dias <= 7 ? 'u-critica' : dias <= 30 ? 'u-alta' : dias <= 90 ? 'u-media' : 'u-info'
}
function fmtFecha(iso: string): string {
  const d = new Date(iso + 'T00:00:00')
  return isNaN(d.getTime()) ? iso : d.toLocaleDateString('es-CO', { day: '2-digit', month: 'short', year: 'numeric' })
}

const eventosFiltrados = computed(() =>
  filtros.calTipo ? eventos.value.filter(e => e.tipo_evento === filtros.calTipo) : eventos.value
)
const eventosFuturos = computed(() =>
  [...eventosFiltrados.value]
    .filter(e => e.dias_restantes >= 0 && ['programado', 'confirmado', 'aplazado'].includes(e.estado))
    .sort((a, b) => a.dias_restantes - b.dias_restantes)
)

/**
 * Historial: lo que ya ocurrió.
 *
 * Los eventos pasados nunca se borran —el backend los conserva y el calendario
 * mensual los sigue pintando—, pero la agenda solo listaba los pendientes, así
 * que desde aquí parecía que desaparecían. Incluye también los cerrados
 * (realizado, cancelado), que por estado tampoco salían en «próximos».
 */
const eventosPasados = computed(() =>
  [...eventosFiltrados.value]
    .filter(e => e.dias_restantes < 0 || ['realizado', 'cancelado'].includes(e.estado))
    // Lo más reciente primero: un historial se lee hacia atrás.
    .sort((a, b) => b.dias_restantes - a.dias_restantes)
)

const verHistorial = ref(false)
const agendaVisible = computed(() => (verHistorial.value ? eventosPasados.value : eventosFuturos.value))

const mesLabel = computed(() => mesRef.value.toLocaleDateString('es-CO', { month: 'long', year: 'numeric' }))
function mover(paso: number): void {
  mesRef.value = new Date(mesRef.value.getFullYear(), mesRef.value.getMonth() + paso, 1)
}

const celdas = computed(() => {
  const y = mesRef.value.getFullYear()
  const m = mesRef.value.getMonth()
  const inicio = (new Date(y, m, 1).getDay() + 6) % 7
  const diasMes = new Date(y, m + 1, 0).getDate()
  const hoyIso = new Date().toISOString().slice(0, 10)

  const porFecha: Record<string, EventoCalendario[]> = {}
  for (const e of eventosFiltrados.value) {
    (porFecha[e.fecha_inicio] ??= []).push(e)
  }

  const arr: Array<{ fecha: string | null; dia: number; esHoy: boolean; eventos: EventoCalendario[] }> = []
  for (let i = 0; i < inicio; i++) arr.push({ fecha: null, dia: 0, esHoy: false, eventos: [] })
  for (let d = 1; d <= diasMes; d++) {
    const fecha = `${y}-${String(m + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`
    arr.push({ fecha, dia: d, esHoy: fecha === hoyIso, eventos: porFecha[fecha] ?? [] })
  }
  return arr
})

/* ── Modal ── */
const modal = ref(false)
const editando = ref<number | null>(null)
const guardando = ref(false)
const errorModal = ref('')
const aplazando = ref(false)
const fechaAplazada = ref('')
const nuevoRecordatorio = ref<number | null>(null)

const form = reactive({
  tipo_evento: 'radicacion',
  titulo: '',
  descripcion: '' as string | null,
  id_area: null as number | null,
  id_campus: null as number | null,
  id_ejecucion: null as number | null,
  fecha_inicio: '',
  fecha_fin: '' as string | null,
  recordatorios: [] as number[],
  destinatarios: { roles: [] as string[], usuarios: [] as number[] }
})

const procesos = computed(() => procesosStore.procesos.filter(p => !!p.id))

const usuarioSeleccionado = computed({
  get: () => form.destinatarios.usuarios[0] ?? null,
  set: (v: number | null) => { form.destinatarios.usuarios = v ? [v] : [] }
})

function precargarRecordatorios(): void {
  const t = tipos.value.find(x => x.clave === form.tipo_evento)
  if (t) form.recordatorios = [...t.recordatorios_sugeridos]
}
function agregarRecordatorio(): void {
  const v = nuevoRecordatorio.value
  if (v !== null && v >= 0 && !form.recordatorios.includes(v)) {
    form.recordatorios.push(v)
    form.recordatorios.sort((a, b) => b - a)
  }
  nuevoRecordatorio.value = null
}

function abrirModal(e?: EventoCalendario): void {
  errorModal.value = ''
  aplazando.value = false
  if (e) {
    editando.value = e.id_evento
    form.tipo_evento = e.tipo_evento
    form.titulo = e.titulo
    form.descripcion = e.descripcion ?? ''
    form.id_area = e.id_area
    form.id_campus = e.id_campus
    form.id_ejecucion = e.id_ejecucion
    form.fecha_inicio = e.fecha_inicio
    form.fecha_fin = e.fecha_fin ?? ''
    form.recordatorios = [...(e.recordatorios ?? e.recordatorios_efectivos)]
    form.destinatarios = {
      roles: [...(e.destinatarios?.roles ?? [])],
      usuarios: [...(e.destinatarios?.usuarios ?? [])]
    }
  } else {
    editando.value = null
    form.titulo = ''
    form.descripcion = ''
    form.id_area = null
    form.id_campus = null
    form.id_ejecucion = null
    form.fecha_inicio = ''
    form.fecha_fin = ''
    form.destinatarios = { roles: [], usuarios: [] }
    precargarRecordatorios()
  }
  modal.value = true
}

function verDetalle(e: EventoCalendario): void {
  // Lectura sin permiso de gestión: modal solo informativo (reutiliza el mismo, sin guardar).
  abrirModal(e)
}

async function guardar(): Promise<void> {
  if (!puedeGestionar.value) { modal.value = false; return }
  errorModal.value = ''
  guardando.value = true
  const payload = {
    ...form,
    descripcion: form.descripcion || null,
    fecha_fin: form.fecha_fin || null
  }
  const r = editando.value
    ? await actualizarEventoService(editando.value, payload)
    : await crearEventoService(payload)
  guardando.value = false
  if (r.ok) {
    modal.value = false
    cargar()
  } else {
    errorModal.value = r.error ?? 'No se pudo guardar'
  }
}

async function cambiarEstado(estado: EstadoEvento): Promise<void> {
  if (!editando.value) return
  const r = await cambiarEstadoEventoService(editando.value, estado)
  if (r.ok) { modal.value = false; cargar() } else { errorModal.value = r.error ?? 'Error' }
}

async function aplazar(): Promise<void> {
  if (!editando.value || !fechaAplazada.value) return
  const r = await cambiarEstadoEventoService(editando.value, 'aplazado', fechaAplazada.value)
  if (r.ok) { modal.value = false; aplazando.value = false; cargar() } else { errorModal.value = r.error ?? 'Error' }
}

async function cargar(): Promise<void> {
  cargando.value = true
  error.value = ''
  const r = await getEventosService()
  if (r.ok && r.data) eventos.value = r.data
  else error.value = r.error ?? 'No se pudo cargar el calendario'
  cargando.value = false
}

onMounted(async () => {
  cargar()
  const t = await getTiposEventoService()
  if (t.ok && t.data) tipos.value = t.data
  if (puedeGestionar.value) {
    roles.value = await listarRoles().catch(() => [])
    usuarios.value = (await listarUsuarios().catch(() => [])).filter(u => !!u.id) as never
    try { areas.value = (await getProgramasService()) as never } catch { /* opcional */ }
    campusList.value = await getCampusService().catch(() => [])
    if (!procesosStore.procesos.length) procesosStore.cargarTodos()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[26] || (_cache[26] = _createElementVNode("div", null, [
        _createElementVNode("h1", null, "Calendario de acreditación"),
        _createElementVNode("p", { class: "sub" }, "Fechas regulatorias registradas por la Dirección de Calidad — el sistema las vigila y avisa.")
      ], -1)),
      (puedeGestionar.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn primario",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (abrirModal()))
          }, "+ Registrar evento"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: _normalizeClass(["tab", { activo: _unref(filtros).calVista === 'mes' }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(filtros).calVista = 'mes'))
        }, "Vista mensual", 2),
        _createElementVNode("button", {
          class: _normalizeClass(["tab", { activo: _unref(filtros).calVista === 'agenda' }]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(filtros).calVista = 'agenda'))
        }, "Agenda", 2)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(filtros).calTipo) = $event))
        }, [
          _cache[27] || (_cache[27] = _createElementVNode("option", { value: "" }, "Todos los tipos", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tipos.value, (t) => {
            return (_openBlock(), _createElementBlock("option", {
              key: t.clave,
              value: t.clave
            }, _toDisplayString(t.label), 9, _hoisted_6))
          }), 128))
        ], 512), [
          [_vModelSelect, _unref(filtros).calTipo]
        ])
      ])
    ]),
    (cargando.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[28] || (_cache[28] = [
          _createElementVNode("div", {
            class: "skeleton",
            style: {"height":"320px"}
          }, null, -1)
        ])))
      : (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createTextVNode(_toDisplayString(error.value) + " ", 1),
            _createElementVNode("button", {
              class: "btn chico",
              onClick: cargar
            }, "Reintentar")
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (_unref(filtros).calVista === 'mes')
              ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("button", {
                      class: "btn-nav",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (mover(-1)))
                    }, "‹"),
                    _createElementVNode("h2", null, _toDisplayString(mesLabel.value), 1),
                    _createElementVNode("button", {
                      class: "btn-nav",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (mover(1)))
                    }, "›")
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Lun','Mar','Mié','Jue','Vie','Sáb','Dom'], (d) => {
                        return _createElementVNode("span", {
                          key: d,
                          class: "dow"
                        }, _toDisplayString(d), 1)
                      }), 64)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(celdas.value, (c, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: i,
                          class: _normalizeClass(["celda", { vacia: !c.fecha, hoy: c.esHoy }])
                        }, [
                          (c.fecha)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("span", _hoisted_13, _toDisplayString(c.dia), 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(c.eventos, (e) => {
                                  return (_openBlock(), _createElementBlock("button", {
                                    key: e.id_evento,
                                    class: _normalizeClass(["chip-ev", 't-' + colorTipo(e.tipo_evento)]),
                                    title: `${e.tipo_label} · ${e.titulo}`,
                                    onClick: ($event: any) => (puedeGestionar.value ? abrirModal(e) : verDetalle(e))
                                  }, _toDisplayString(e.titulo), 11, _hoisted_14))
                                }), 128))
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 2))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(LEYENDA, (lbl, k) => {
                      return _createElementVNode("span", {
                        key: k,
                        class: "leyenda-item"
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["pto", 't-' + k])
                        }, null, 2),
                        _createTextVNode(_toDisplayString(lbl), 1)
                      ])
                    }), 64))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("section", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("button", {
                      class: _normalizeClass({ activo: !verHistorial.value }),
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (verHistorial.value = false))
                    }, " Próximos (" + _toDisplayString(eventosFuturos.value.length) + ") ", 3),
                    _createElementVNode("button", {
                      class: _normalizeClass({ activo: verHistorial.value }),
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (verHistorial.value = true))
                    }, " Historial (" + _toDisplayString(eventosPasados.value.length) + ") ", 3)
                  ]),
                  (!agendaVisible.value.length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                        (verHistorial.value)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode("Todavía no hay eventos pasados.")
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _cache[30] || (_cache[30] = _createTextVNode(" No hay eventos próximos")),
                              (puedeGestionar.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _cache[29] || (_cache[29] = _createTextVNode(" — ")),
                                    _createElementVNode("a", {
                                      href: "#",
                                      onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (abrirModal()), ["prevent"]))
                                    }, "registra el primero")
                                  ], 64))
                                : _createCommentVNode("", true),
                              _cache[31] || (_cache[31] = _createTextVNode(". "))
                            ], 64))
                      ]))
                    : (_openBlock(), _createElementBlock("ul", _hoisted_19, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(agendaVisible.value, (e) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: e.id_evento,
                            class: _normalizeClass(["agenda-item", { pasado: verHistorial.value }]),
                            onClick: ($event: any) => (puedeGestionar.value ? abrirModal(e) : verDetalle(e))
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["cuenta", verHistorial.value ? 'u-pasado' : urgencia(e.dias_restantes)])
                            }, [
                              _createElementVNode("span", _hoisted_21, _toDisplayString(Math.abs(e.dias_restantes)), 1),
                              _createElementVNode("span", _hoisted_22, _toDisplayString(verHistorial.value ? 'día(s) atrás' : 'día(s)'), 1)
                            ], 2),
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("span", _hoisted_24, _toDisplayString(e.titulo), 1),
                              _createElementVNode("span", _hoisted_25, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["chip-tipo", 't-' + colorTipo(e.tipo_evento)])
                                }, _toDisplayString(e.tipo_label), 3),
                                _createTextVNode(" " + _toDisplayString(fmtFecha(e.fecha_inicio)), 1),
                                (e.fecha_fin)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(" – " + _toDisplayString(fmtFecha(e.fecha_fin)), 1)
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (e.area)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(" · " + _toDisplayString(e.area.nombre), 1)
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (e.campus)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                      _createTextVNode(" · " + _toDisplayString(e.campus.nombre), 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("span", {
                              class: _normalizeClass(["estado-ev", 'e-' + e.estado])
                            }, _toDisplayString(e.estado), 3)
                          ], 10, _hoisted_20))
                        }), 128))
                      ]))
                ]))
          ], 64)),
    (modal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("h3", null, _toDisplayString(editando.value ? 'Editar evento' : 'Registrar evento'), 1),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("label", null, [
                _cache[32] || (_cache[32] = _createTextVNode("Tipo de evento ")),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.tipo_evento) = $event)),
                  onChange: precargarRecordatorios
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tipos.value, (t) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: t.clave,
                      value: t.clave
                    }, _toDisplayString(t.label), 9, _hoisted_29))
                  }), 128))
                ], 544), [
                  [_vModelSelect, form.tipo_evento]
                ])
              ]),
              _createElementVNode("label", null, [
                _cache[33] || (_cache[33] = _createTextVNode("Título")),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.titulo) = $event)),
                  type: "text",
                  maxlength: "200",
                  placeholder: "p. ej. Radicación SACES-CNA Ing. Sistemas"
                }, null, 512), [
                  [_vModelText, form.titulo]
                ])
              ]),
              _createElementVNode("label", null, [
                _cache[34] || (_cache[34] = _createTextVNode("Fecha inicio")),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.fecha_inicio) = $event)),
                  type: "date"
                }, null, 512), [
                  [_vModelText, form.fecha_inicio]
                ])
              ]),
              _createElementVNode("label", null, [
                _cache[35] || (_cache[35] = _createTextVNode("Fecha fin (opcional)")),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.fecha_fin) = $event)),
                  type: "date"
                }, null, 512), [
                  [_vModelText, form.fecha_fin]
                ])
              ]),
              _createElementVNode("label", null, [
                _cache[37] || (_cache[37] = _createTextVNode("Programa (opcional) ")),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.id_area) = $event))
                }, [
                  _cache[36] || (_cache[36] = _createElementVNode("option", { value: null }, "— Institucional / N/A —", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(areasAgrupadas.value, (g) => {
                    return (_openBlock(), _createElementBlock("optgroup", {
                      key: g.tipo,
                      label: g.tipo
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(g.areas, (a) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: a.id_programa,
                          value: a.id_programa
                        }, _toDisplayString(a.nombre), 9, _hoisted_31))
                      }), 128))
                    ], 8, _hoisted_30))
                  }), 128))
                ], 512), [
                  [_vModelSelect, form.id_area]
                ])
              ]),
              _createElementVNode("label", null, [
                _cache[39] || (_cache[39] = _createTextVNode("Campus (opcional) ")),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.id_campus) = $event))
                }, [
                  _cache[38] || (_cache[38] = _createElementVNode("option", { value: null }, "— Todos los campus —", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(campusList.value, (c) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: c.id_campus,
                      value: c.id_campus
                    }, _toDisplayString(c.nombre), 9, _hoisted_32))
                  }), 128))
                ], 512), [
                  [_vModelSelect, form.id_campus]
                ])
              ]),
              _createElementVNode("label", null, [
                _cache[41] || (_cache[41] = _createTextVNode("Proceso asociado (opcional) ")),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.id_ejecucion) = $event))
                }, [
                  _cache[40] || (_cache[40] = _createElementVNode("option", { value: null }, "— Ninguno —", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(procesos.value, (p) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: p.id,
                      value: p.id
                    }, _toDisplayString(p.area?.nombre ?? 'Institucional') + " · " + _toDisplayString(p.periodo), 9, _hoisted_33))
                  }), 128))
                ], 512), [
                  [_vModelSelect, form.id_ejecucion]
                ])
              ])
            ]),
            _createElementVNode("label", _hoisted_34, [
              _cache[42] || (_cache[42] = _createTextVNode("Descripción ")),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.descripcion) = $event)),
                rows: "2",
                placeholder: "Agenda de la visita, requisitos de la radicación…"
              }, null, 512), [
                [_vModelText, form.descripcion]
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _cache[43] || (_cache[43] = _createElementVNode("span", { class: "lbl" }, "Recordatorios (días de antelación)", -1)),
              _createElementVNode("div", _hoisted_36, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.recordatorios, (d, i) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: i,
                    class: "chip-dia"
                  }, [
                    _createTextVNode(_toDisplayString(d) + " d ", 1),
                    _createElementVNode("button", {
                      class: "x",
                      onClick: ($event: any) => (form.recordatorios.splice(i, 1))
                    }, "×", 8, _hoisted_37)
                  ]))
                }), 128)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((nuevoRecordatorio).value = $event)),
                  type: "number",
                  min: "0",
                  max: "730",
                  class: "chip-input",
                  placeholder: "+ días",
                  onKeyup: _withKeys(agregarRecordatorio, ["enter"])
                }, null, 544), [
                  [
                    _vModelText,
                    nuevoRecordatorio.value,
                    void 0,
                    { number: true }
                  ]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _cache[47] || (_cache[47] = _createElementVNode("span", { class: "lbl" }, "Destinatarios de los avisos", -1)),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", null, [
                  _cache[44] || (_cache[44] = _createElementVNode("span", { class: "lbl-mini" }, "Por rol", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roles.value, (r) => {
                    return (_openBlock(), _createElementBlock("label", {
                      key: r.id,
                      class: "chk"
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((form.destinatarios.roles) = $event)),
                        type: "checkbox",
                        value: r.name
                      }, null, 8, _hoisted_40), [
                        [_vModelCheckbox, form.destinatarios.roles]
                      ]),
                      _createTextVNode(" " + _toDisplayString(r.label ?? r.name), 1)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", null, [
                  _cache[46] || (_cache[46] = _createElementVNode("span", { class: "lbl-mini" }, "Por usuario", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((usuarioSeleccionado).value = $event))
                  }, [
                    _cache[45] || (_cache[45] = _createElementVNode("option", { value: null }, "— Ninguno —", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usuarios.value, (u) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: u.id,
                        value: u.id
                      }, _toDisplayString(u.name), 9, _hoisted_41))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, usuarioSeleccionado.value]
                  ])
                ])
              ])
            ]),
            (errorModal.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_42, _toDisplayString(errorModal.value), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_43, [
              (editando.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                    _createElementVNode("button", {
                      class: "btn chico",
                      onClick: _cache[20] || (_cache[20] = ($event: any) => (cambiarEstado('confirmado')))
                    }, "Confirmar"),
                    _createElementVNode("button", {
                      class: "btn chico ok",
                      onClick: _cache[21] || (_cache[21] = ($event: any) => (cambiarEstado('cumplido')))
                    }, "Cumplido"),
                    _createElementVNode("button", {
                      class: "btn chico",
                      onClick: _cache[22] || (_cache[22] = ($event: any) => (aplazando.value = !aplazando.value))
                    }, "Aplazar…"),
                    _createElementVNode("button", {
                      class: "btn chico peligro",
                      onClick: _cache[23] || (_cache[23] = ($event: any) => (cambiarEstado('cancelado')))
                    }, "Cancelar evento")
                  ]))
                : _createCommentVNode("", true),
              (aplazando.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                    _cache[48] || (_cache[48] = _createTextVNode(" Nueva fecha: ")),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((fechaAplazada).value = $event)),
                      type: "date"
                    }, null, 512), [
                      [_vModelText, fechaAplazada.value]
                    ]),
                    _createElementVNode("button", {
                      class: "btn chico primario",
                      onClick: aplazar
                    }, "Aplazar")
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("button", {
                  class: "btn",
                  onClick: _cache[25] || (_cache[25] = ($event: any) => (modal.value = false))
                }, "Cerrar"),
                _createElementVNode("button", {
                  class: "btn primario",
                  disabled: guardando.value,
                  onClick: guardar
                }, _toDisplayString(guardando.value ? 'Guardando…' : 'Guardar'), 9, _hoisted_47)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})